import { AbstractControl, ValidatorFn } from '@angular/forms';


export function timezoneValidator(tzNames: { id: string, name: string }[]): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    return tzNames.map(tzName => tzName.id).includes(control.value)
      ? null
      : { timezoneValidator: { value: control.value } };
  };
}
